export enum TipoStatusNotificacaoEnum {

    SUC = 'SUC',

    WRN = 'WRN',

    ERR = 'ERR'
}

export namespace TipoStatusNotificacaoEnum {

    export function values() {
        return Object.keys(TipoStatusNotificacaoEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }

    export function getFromCode(value: string): TipoStatusNotificacaoEnum | null {
        if (value === 'SUC') {
            return TipoStatusNotificacaoEnum.SUC;
        } else if (value === 'WRN') {
            return TipoStatusNotificacaoEnum.WRN;
        } else if (value === 'ERR') {
            return TipoStatusNotificacaoEnum.ERR;
        } else {
            return null;
        }
    }

}